import React from 'react';
import { Wind, Bath, Frame, DoorClosed, ArrowRight } from 'lucide-react';

const Services = () => {
  const services = [
    {
      id: 1,
      icon: <Wind className="w-10 h-10" />,
      title: 'Envidraçamento de Sacadas',
      description: 'Transforme sua sacada em um ambiente protegido e elegante. Sistema frameless ou com perfis pretos e dourados.',
      image: '/assets/images/sacada-1.jpg',
      featured: true,
    },
    {
      id: 2,
      icon: <Bath className="w-10 h-10" />,
      title: 'Box para Banheiro',
      description: 'Boxes sob medida com acabamento premium. Perfis pretos, dourados, jateados e diversos estilos.',
      image: '/assets/images/box-1.jpg',
      featured: false,
    },
    {
      id: 3,
      icon: <Frame className="w-10 h-10" />,
      title: 'Espelhos',
      description: 'Espelhos lapidados, bisotê e com iluminação LED. Design personalizado para seu ambiente.',
      image: '/assets/images/espelho-1.jpg',
      featured: false,
    },
    {
      id: 4,
      icon: <DoorClosed className="w-10 h-10" />,
      title: 'Portas e Divisórias',
      description: 'Portas de vidro e divisórias para áreas internas. Vidro canelado, jateado e transparente.',
      image: '/assets/images/porta-1.jpg',
      featured: false,
    },
  ];

  return (
    <section id="services" className="section-padding bg-[var(--bg-secondary)]">
      <div className="container-custom">
        {/* Header */}
        <div className="text-center mb-16">
          <h2 className="heading-1 mb-4">Nossos Serviços</h2>
          <p className="body-regular text-[var(--text-secondary)] max-w-2xl mx-auto">
            Soluções completas em vidro para transformar seus ambientes com qualidade e sofisticação
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {services.map((service, index) => (
            <div
              key={service.id}
              className={`group bg-white overflow-hidden hover-lift fade-in ${
                service.featured ? 'md:col-span-2' : ''
              }`}
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              <div className={`grid ${service.featured ? 'md:grid-cols-2' : 'grid-cols-1'} h-full`}>
                {/* Image */}
                <div className="relative h-64 md:h-80 overflow-hidden">
                  <img
                    src={service.image}
                    alt={service.title}
                    className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>
                  
                  {/* Featured Badge */}
                  {service.featured && (
                    <div className="absolute top-4 left-4 bg-[var(--accent-gold)] text-white px-4 py-2 text-xs font-semibold uppercase">
                      Serviço Principal
                    </div>
                  )}
                </div>

                {/* Content */}
                <div className="p-8 flex flex-col justify-center">
                  <div className="text-[var(--accent-gold)] mb-4">
                    {service.icon}
                  </div>
                  <h3 className="heading-3 mb-4">{service.title}</h3>
                  <p className="body-regular text-[var(--text-secondary)] mb-6">
                    {service.description}
                  </p>
                  <a
                    href="https://wa.me/5515991253527?text=Olá!%20Gostaria%20de%20um%20orçamento%20para%20"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center gap-2 text-[var(--text-primary)] hover:text-[var(--accent-gold)] transition-colors group/link"
                  >
                    <span className="font-medium">Solicitar orçamento</span>
                    <ArrowRight className="w-4 h-4 transition-transform group-hover/link:translate-x-1" />
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Additional Info */}
        <div className="mt-16 bg-white p-8 text-center">
          <h3 className="heading-3 mb-4">Projetos Personalizados</h3>
          <p className="body-regular text-[var(--text-secondary)] mb-6 max-w-2xl mx-auto">
            Também trabalhamos com janelas, tampos de mesa, vidros jateados, adesivados e serigrafados.
            Entre em contato para projetos especiais.
          </p>
          <a
            href="https://wa.me/5515991253527?text=Olá!%20Gostaria%20de%20fazer%20um%20projeto%20personalizado."
            target="_blank"
            rel="noopener noreferrer"
            className="btn-primary"
          >
            Fale sobre seu projeto
          </a>
        </div>
      </div>
    </section>
  );
};

export default Services;
